import saveAs from 'file-saver';

import {
  Filters,
  FORM_STATUS,
  formatFilters,
  handleRequest,
  privateClient,
  publicClient,
} from '@data-access';

import {
  HarvestProofForm,
  HarvestProofFormPublic,
  HarvestProofFormsResponse,
  SubmitHarvestProofAnswerResponse,
} from '../types/harvest-proof';

export const harvestProofApi = {
  getPublicForm: (token: string) =>
    handleRequest<HarvestProofFormPublic>(
      publicClient
        .get('harvestproofform/', { searchParams: { token } })
        .json(),
    ),

  submitAnswer: ({
    token,
    answerId,
    formData,
  }: {
    token: string;
    answerId: number;
    formData: FormData;
  }) =>
    handleRequest<SubmitHarvestProofAnswerResponse>(
      publicClient
        .post(`harvestproofanswers/${answerId}/`, {
          searchParams: { token },
          body: formData,
        })
        .json(),
    ),

  list: (filters: Filters) =>
    handleRequest<HarvestProofFormsResponse>(
      privateClient
        .get('harvestproofforms/', {
          searchParams: formatFilters(filters),
        })
        .json(),
    ),

  getOne: (id: number) =>
    handleRequest<HarvestProofForm>(
      privateClient.get(`harvestproofforms/${id}/`).json(),
    ),

  forceSendSms: (id: number) =>
    handleRequest<HarvestProofForm>(
      privateClient.post(`harvestproofforms/${id}/force_send_sms/`).json(),
    ),

  reset: (id: number) =>
    handleRequest<HarvestProofForm>(
      privateClient.post(`harvestproofforms/${id}/reset/`, { json: {} }).json(),
    ),

  prepSynthesis: () =>
    handleRequest<{ id: number; status: FORM_STATUS; instance_id: number }>(
      privateClient.post('harvestproofforms/prep_synthesis/').json(),
    ),

  downloadSynthesis: async (opts: { id: number }) => {
    const res = await handleRequest(
      privateClient.post('harvestproofforms/synthesis/', {
        json: { instance_id: opts.id },
      }),
    );

    const filename = res.headers
      .get('content-disposition')
      ?.split(';')
      .find((n: string) => n.includes('filename='))
      ?.replace('filename=', '')
      .trim();

    const blob = await res.blob();
    saveAs(blob, filename);
    return res;
  },
};
